import { render } from "./BaseNotification.vue?vue&type=template&id=427abcb2&scoped=true&ts=true"
import script from "./BaseNotification.vue?vue&type=script&lang=ts"
export * from "./BaseNotification.vue?vue&type=script&lang=ts"

import "./BaseNotification.vue?vue&type=style&index=0&id=427abcb2&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427abcb2"]])

export default __exports__